"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNameFormat = function (nameString) { return /^[a-zA-Z]+([-?\s?'?][a-zA-Z]+)*$/.test(nameString); };
//# sourceMappingURL=isNameFormat.js.map